import { render, staticRenderFns } from "./SubmitBtn.vue?vue&type=template&id=15f8f7e8&scoped=true"
import script from "./SubmitBtn.vue?vue&type=script&lang=js"
export * from "./SubmitBtn.vue?vue&type=script&lang=js"
import style0 from "./submitBtn.scss?vue&type=style&index=0&id=15f8f7e8&prod&scoped=true&lang=scss&external"
import style1 from "./SubmitBtn.vue?vue&type=style&index=1&id=15f8f7e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f8f7e8",
  null
  
)

export default component.exports